import React, { Fragment } from 'react'
import styled from 'styled-components'
import { Theme } from '@pga/pga-component-library'

export const FilterHeader = styled.h5`
  font-family: ${Theme.fonts.Montserrat};
  font-weight: bold;
  text-align: left;
  color: ${Theme.colors.primary};

  font-size: 12px;
  letter-spacing: -0.15px;
  line-height: 15px;
  text-transform: uppercase;
  margin-top: 8px;
`
FilterHeader.displayName = 'FilterHeader'

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  :nth-child(n + 3) {
    border-top: 1px solid ${Theme.colors.darkgrey};
    padding-top: 20px;
    padding-bottom: 20px;
  }
`
FilterContainer.displayName = 'FilterContainer'

const FilterItem = ({ filterName, children }) => (
  <FilterContainer>
    <Fragment>
      <FilterHeader>{filterName}</FilterHeader>
      {children}
    </Fragment>
  </FilterContainer>
)
FilterItem.displayName = 'FilterItem'

export default FilterItem
